import { useTeamCollectionHeal } from '../hooks/useTeamCollectionHeal';
import { useTeamDeckCleanup } from '../hooks/useTeamDeckCleanup';
import { useTeamDirectorySync } from '../hooks/useTeamDirectorySync';

/** Mount inside AuthProvider for team join/leave side effects. */
export function TeamLifecycleEffects() {
  useTeamDeckCleanup();
  useTeamCollectionHeal();
  useTeamDirectorySync();
  return null;
}
